import { Button } from "@components/shadcn-ui/button";
import { CircleCheckBig } from "lucide-react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@components/shadcn-ui/accordian";
import { FileCategory } from "./FileCategoryModal";
import { CategorizedFiles } from "./FileUploadComponent";
import { formatFileSize, toTitleCase } from "../utils";

interface UploadedFileCardListProps {
  openImageModal: (image: string, e?: any) => void;
  handleFileUpload: (index: number, category: any) => void;
  categorizedFiles: CategorizedFiles;
}

export const UploadedFileCardList = ({
  openImageModal,
  handleFileUpload,
  categorizedFiles,
}: UploadedFileCardListProps) => {
  return (
    <>
      {Object.keys(categorizedFiles).length > 0 && (
        <Accordion
          type="single"
          collapsible
          defaultValue={Object.keys(categorizedFiles)[0]}
        >
          <div className="mt-6">
            <h3 className="text-lg font-bold mb-2 text-center bg-[#f7eec9] p-3">
              Recently uploaded files
            </h3>
            {Object.entries(categorizedFiles).map(
              ([category, { files, previews, progress, uploadStatus }]) => (
                <AccordionItem key={category} value={category} className="mt-2">
                  <AccordionTrigger className="text-md font-semibold bg-[#bbd0ce] p-3 rounded-sm">
                    {toTitleCase(category)}
                  </AccordionTrigger>
                  <AccordionContent className="mt-1">
                    <div className="flex flex-col gap-1 mt-2">
                      {files.map((file, index) => (
                        <div
                          key={index}
                          className="flex items-center bg-white p-4 rounded-md gap-3 h-32 shadow-sm"
                        >
                          {previews[index] === "non-image" ? (
                            <div className="w-20 h-28 bg-gray-200 flex justify-center items-center rounded-sm">
                              <p className="text-xs text-center">{file.name}</p>
                            </div>
                          ) : (
                            <div className="h-full flex items-center border-gray-300 border-2 p-[1px] rounded-sm relative">
                              <div
                                onClick={(e) =>
                                  openImageModal(previews[index], e)
                                }
                                className="absolute w-full h-full flex items-center justify-center"
                              ></div>
                              <img
                                src={previews[index]}
                                alt={file.name}
                                className="w-20 h-full object-cover rounded-sm cursor-pointer"
                                onClick={(e) =>
                                  openImageModal(previews[index], e)
                                }
                              />
                            </div>
                          )}
                          <div className="flex flex-col flex-grow gap-2 h-full justify-between">
                            <div>
                              <p className="mb-1 text-sm text-gray-500 dark:text-gray-400">
                                {file.name}
                              </p>
                              <div className="flex justify-between">
                                <p className="text-xs text-gray-500">
                                  {formatFileSize(file.size)}
                                </p>
                              </div>
                            </div>

                            <div className="flex space-x-2 justify-between items-center">
                              <div className="flex-1">
                                <Button
                                  variant={"secondary"}
                                  className="h-7 w-full relative rounded-xl overflow-hidden bg-[#dbe9f7eb]"
                                  onClick={() =>
                                    handleFileUpload(
                                      index,
                                      category as FileCategory
                                    )
                                  }
                                >
                                  <span
                                    className={`absolute left-0 bg-blue-400 h-full bottom-0`}
                                    style={{ width: `${progress[index]}%` }}
                                  ></span>
                                  <p
                                    className={`text-sm absolute text-black flex items-center`}
                                  >
                                    {progress[index] > 0 &&
                                      progress[index] !== 100 &&
                                      `${progress[index]}%`}

                                    {uploadStatus[index] === "success" ? (
                                      <>
                                        <CircleCheckBig className="w-6 h-6 text-white mr-3" />
                                        <span>Uploaded successfully.</span>{" "}
                                      </>
                                    ) : (
                                      "Upload file"
                                    )}
                                  </p>
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </AccordionContent>
                </AccordionItem>
              )
            )}
          </div>
        </Accordion>
      )}
    </>
  );
};
